module.exports = __webpack_public_path__ + "img/carrier2.dd1f1c25.png";